var _UnsignedInt32_value;
import { __classPrivateFieldGet, __classPrivateFieldSet } from "tslib";
import Exception from '../../Exceptions/Exception';
import { ensureInt } from "./ensureInt";
import Result from '../../Result/Result';
export default class UnsignedInt32 extends Number {
    constructor(value) {
        super(value);
        _UnsignedInt32_value.set(this, void 0);
        ensureInt(value, UnsignedInt32.minValue, UnsignedInt32.maxValue);
        __classPrivateFieldSet(this, _UnsignedInt32_value, value, "f");
    }
    [(_UnsignedInt32_value = new WeakMap(), Symbol.toPrimitive)]() {
        return this.valueOf();
    }
    valueOf() {
        return __classPrivateFieldGet(this, _UnsignedInt32_value, "f").valueOf() & 0xFFFFFFFF;
    }
    toString() {
        return this.valueOf().toString();
    }
    static parse(value) {
        const int = parseInt(value);
        return new UnsignedInt32(int);
    }
    static tryParse(value) {
        const int = parseInt(value);
        try {
            ensureInt(int, UnsignedInt32.minValue, UnsignedInt32.maxValue);
            return Result.ok(new UnsignedInt32(int));
        }
        catch (ex) {
            if (ex instanceof Exception) {
                return Result.fail(ex.message);
            }
            else if (ex instanceof Error) {
                return Result.fail(ex.message);
            }
            else {
                return Result.fail(`${ex}`);
            }
        }
    }
}
/** The largest number that can be represented. Equal to 4,294,967,295. */
UnsignedInt32.maxValue = 4294967295;
/** The lowest number that can be represented. Equal to 0. */
UnsignedInt32.minValue = 0;
